<template>
    <div class="hot_div">
        <!-- <div class="hot_title flex_center">
            <i><img src="@/assets/img/hot.png" alt=""></i>
            <span class="flex_center">热门</span>
        </div> -->
        <div class="hot_list">
            <div class="hot_li flex_between" @click="details(liem.news_id)" v-for="(liem,index) in list">
                <span class="li_num flex_center">{{index+1}}</span>
                <div class="hot_text">
                    {{liem.title}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'popup',
        data() {
            return {

            }
        },
        props: {
            list: {
                type: Array,
            }
        },
        watch: {

        },
        methods: {
            details(id) {//详情
                this.$emit('detailsFun', id);
            }
        },
        mounted() {

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hot_div {
        /* width: 334px;
        background: #fff;
        border-radius: 10px;
        position: fixed;
        right:calc((100% - 1280px) / 2);
        top:74px; */
        width: 100%;
    }

    .hot .hot_title {
        border-bottom: .005rem solid #999999;
    }

    .hot .hot_title>i {
        width: 15px;
        margin-right: 11px;
    }

    .hot .hot_title>span {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        height: 70px;
    }

    .hot_list {
        padding: 10px 8px 15px 8px;
    }

    .hot_list .hot_li {
        margin-bottom: 6px;
        align-items: flex-start;
        cursor: pointer;
        padding: 6px 10px;
        border-radius: 4px;
        transition: all .5s ease;
    }

    .hot_list .hot_li:hover {
        box-shadow: 0 0 20px rgba(240, 240, 240, 1);
    }

    .hot_list .hot_li .li_num {
        height: 22px;
        width: 22px;
        background: #DDDDDD;
        border-radius: 4px;
        color: #333333;
        font-size: 16px;
        margin-right: 4px;
        transform: translateY(2px);
    }

    .hot_list .hot_li .hot_text {
        font-size: 16px;
        flex: 1;
        color: #333;
        line-height: 1.6em;
    }

    .hot_list .hot_li:nth-child(1) .li_num {
        background: #F73D54;
        color: #fff;
    }

    .hot_list .hot_li:nth-child(2) .li_num {
        background: #F78C3D;
        color: #fff;
    }

    .hot_list .hot_li:nth-child(3) .li_num {
        background: #FFC53A;
        color: #fff;
    }

    .hot_list .hot_li:nth-child(4) .li_num {
        background: #46DB2E;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/assembly/hot.vue